import { useQuery } from "@tanstack/vue-query";
import { type MaybeRef } from "@vueuse/core";
import { api } from "@/api";

const KEYCODE_PITCH_QUERY_KEY = "keycode-pitches";

export type KeycodePitch = {
  id: string;
  name: string;
  keycode: string;
  pitchTypeName: string;
  siteId: string;
  isExperienceFreedom: boolean;
};

export type KeycodePitchFilter = {
  siteId: string | null;
  bookingType?: string;
};

export const listKeycodePitches = async (filter: KeycodePitchFilter) => {
  const { body } = await api.get<KeycodePitch[]>("/keycode-pitches", {
    query: filter,
  });
  return body;
};

export const useKeycodePitches = (query?: MaybeRef<KeycodePitchFilter>) => {
  const { id: currentSiteId } = useCurrentSite();

  return useQuery({
    queryKey: [
      KEYCODE_PITCH_QUERY_KEY,
      computed(() => ({
        siteId: currentSiteId.value,
        ...unref(query),
      })),
    ] as const,
    queryFn: ({ queryKey: [_, query_] }) => listKeycodePitches(unref(query_)),
    refetchIntervalInBackground: false,
    refetchInterval: 0,
    staleTime: 60 * 60 * 1000,
  });
};
